import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedNetwork: "",
  selectedVideos: [],
};

const recommendedSlice = createSlice({
  name: "recommended",
  initialState,
  reducers: {
    setSelectedNetwork: (state, action) => {
      state.selectedNetwork = action.payload;
    },
    setSelectedVideos: (state, action) => {
      state.selectedVideos = action.payload;
    },
    addVideoToRecommended: (state, action) => {
      if (
        !state.selectedVideos.some((v) => v.id === action.payload.id)
      ) {
        state.selectedVideos.push(action.payload);
      }
    },
    removeVideoFromRecommended: (state, action) => {
      state.selectedVideos = state.selectedVideos.filter(
        (v) => v.id !== action.payload
      );
    },
    resetRecommendedState: (state) => {
      state.selectedNetwork = "";
      state.selectedVideos = [];
    },
  },
});

export const {
  setSelectedNetwork,
  setSelectedVideos,
  addVideoToRecommended,
  removeVideoFromRecommended,
  resetRecommendedState,
} = recommendedSlice.actions;

export default recommendedSlice.reducer;
